import { Text, Card, Group, Title, Button } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { IconDownload } from "@tabler/icons-react";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useRef, useCallback } from "react";
import { THandler } from "@/components/table/Table";
import useNonDeletedGlobalFilters from "@/hooks/useNonDeletedGlobalFilters";
import IdeiaStatusBadge, { colorsMap } from "@/modules/ideias/components/ideia-status-badge/IdeiaStatusBadge";
import IdeiasTable from "@/modules/ideias/components/ideias-table/IdeiasTopTable";
import { textMapIdeias, textMapDesafios } from "./ExportIdeias";
import ideiaColumns, { ideiaColumnsMobile } from "./IdeiaColumns";
import useGetAllDesafios from "./useGetAllDesafios";
const ULTIMAS_IDEIAS_ATUALIZADAS_LIMIT = 10;

// prettier-ignore
const IdeiaStatusLegend = () => {
  const allStatus = Object.keys(colorsMap) as TIdeia["status"][];

  return (
    <>
      <Text fw={500}>Legenda</Text>
      <Group mt="md">
        {allStatus.map((status) => (
          <IdeiaStatusBadge key={status} status={status} />
        ))}
      </Group>
    </>
  );
};
// prettier-ignore
const UltimasIdeiasAtualizadasCard = () => {
  const tableHandlersIdeiasReference = useRef<THandler<TIdeia>>(null);
  useNonDeletedGlobalFilters(tableHandlersIdeiasReference);
  const isSmMarches = useMediaQuery("(max-width: 48em)");

  const { data: desafios } = useGetAllDesafios();

  const formatDesafios = desafios?.map((item: TDesafio, index: number) => {
    return [
      index,
      item.titulo,
      item.descricao,
      item.objetivo,
      textMapDesafios[item.status]
    ];
  });

  const handleExport = useCallback(async () => {
    const currentTableData = tableHandlersIdeiasReference.current?.data;

    if (!currentTableData?.entries) return;

    const formatIdeias = currentTableData.entries.map((item: TIdeia, index: number) => {
      return [
        index + 1,
        item.titulo,
        item.descricao,
        item.descricaoProblema,
        item.diferenciais,
        item.feedback,
        textMapIdeias[item.status]
      ];
    });

    const columns = ["Ordem", "Título", "Descrição", "Descrição do problema", "diferencias", "Feedback", "Status"];
    const columnsDesafios = ["Ordem", "Título", "Descrição", "Objetivo", "Status"];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Ideias');
    const worksheetDesafios = workbook.addWorksheet('Desafios');

    const headerRow = worksheet.addRow(columns);
    const headerRowDesafios = worksheetDesafios.addRow(columnsDesafios);

    headerRow.eachCell((cell: ExcelJS.Cell) => {
      cell.font = { bold: true };
    });

    headerRowDesafios.eachCell((cell: ExcelJS.Cell) => {
      cell.font = { bold: true };
    });

    if (Array.isArray(formatIdeias)) {
      for (const rowData of formatIdeias) {
        worksheet.addRow(Object.values(rowData));
      }
    }

    if (Array.isArray(formatDesafios)) {
      for (const rowData of formatDesafios) {
        worksheetDesafios.addRow(Object.values(rowData));
      }
    }

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], { type: "application/octet-stream" }),
        `relatorio.xlsx`
      );
    } catch (error) {
      console.error("Erro ao escrever buffer:", error);
    }
  }, []);

  const onExportClick = useCallback(() => {
    void handleExport().catch((error: Error) => {
      console.error("Erro ao exportar ideias:", error);
    });
  }, [handleExport]);

  return (
    <Card withBorder>
      <Card.Section inheritPadding py="md">
        <Group justify={"space-between"} mb="md">
          <Title order={3} fw={500}>
            As {ULTIMAS_IDEIAS_ATUALIZADAS_LIMIT} últimas ideias mais curtidas na empresa
          </Title>
          <Button variant="filled" leftSection={<IconDownload size="1rem" />} onClick={onExportClick}>
            Exportar
          </Button>
        </Group>
        <Card withBorder p={0}>
          <IdeiasTable ref={tableHandlersIdeiasReference} columns={isSmMarches ? ideiaColumnsMobile : ideiaColumns} />
        </Card>
      </Card.Section>
      {isSmMarches ? <></> : <Card.Section inheritPadding pb="md">
        <Card withBorder>
          <IdeiaStatusLegend />
        </Card>
      </Card.Section>}
    </Card>
  );
};

export default UltimasIdeiasAtualizadasCard;
